import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalController, NavController, NavParams } from '@ionic/angular';
import { AbstractPage } from '../AbstractPage';
import { OreTipoAttivita } from '../models/didattica/ore-tipo-attivita';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-info-suddivisione',
  templateUrl: './info-suddivisione.page.html',
  styleUrls: ['./info-suddivisione.page.scss'],
  standalone: false
})
export class InfoSuddivisionePage extends AbstractPage implements OnInit {
  suddivisioneOre: OreTipoAttivita[];
  verificaSuddivisioni: boolean;
  viewAsStudent: boolean;
  studentMessage: string;


  constructor (
    public navCtrl: NavController,
    public router: Router,
    // public route: ActivatedRoute,
    // private loadingCtrl: LoadingController,
    private translateService: TranslateService,
    public modalCtrl: ModalController,
    // private formBuilder: FormBuilder,
    // private rilevazionePresenzeService: RilevazionePresenzeService,
    public navParams: NavParams,
    // private utilityService: UtilityService,
    // public configService: ConfigService,
    // public userService: UserService
  ) {
     super(navCtrl, router);
    this.suddivisioneOre = this.navParams.data.suddivisioneOre;
    this.viewAsStudent = this.navParams.data.viewAsStudent;
    this.verificaSuddivisioni = this.navParams.data.verificaSuddivisioni;
  }

  ngOnInit() {
    console.log('ngOnInit', this.suddivisioneOre);
    console.log('verificaSuddivisioni', this.verificaSuddivisioni);
    if (this.verificaSuddivisioni!==undefined) {
        this.studentMessage = this.translateService.instant('info-suddivisione.message.verificasuddivisione' , 
          {non: this.verificaSuddivisioni? '': 'non '});
    }
  }

  cancel() {
    this.modalCtrl.dismiss();
  }
}